<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/CEVCSs/tc-custom/9781460346624.jpg?1740828049831" alt="This image is the cover for the book Innocent Virgin"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Innocent Virgin
      </h1>
      <p class="bookDescription body article font2">
        <p>Parting with danger Abby Freeman is thrilled that, at last, she's landed herself a fantastic job as a TV chat-show host. But she needs to prove herself with a ratings-pulling interview. Who better to grill than thefamous, darkly handsome journalist Max Harding? He has an intriguing scandal in his past that has never been fully explained Max is happy to let Abbyget closebut only in private; he, and his life, are not for public consumption. Now Abby has two dilemmas: she doesn't want to lose Max's story but she's in danger of losing her innocence! Because, clearly, Max doesn't realise that the apparently worldly Abby is still a virgin</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Carole Mortimer
      </h2>
      
      <p class="authorDescription body article">Carole Mortimer was born in England, the youngest of three children. She began writing in 1978, and has now written over one hundred and seventy books for Harlequin Mills and Boon&reg;. Carole has six sons, Matthew, Joshua, Timothy, Michael, David and Peter. She says, &lsquo;I&rsquo;m happily married to Peter senior; we&rsquo;re best friends as well as lovers, which is probably the best recipe for a successful relationship. We live in a lovely part of England.&rsquo;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7cf2e720